import { Holiday, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeHoliday(httpClient: HttpClient) {
  return (holiday: Holiday) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/holidays/${holiday.uuid}`,
        method: HttpMethods.DELETE,
      })
      .then(() => holiday);
}

export { removeHoliday };
